import { onMounted, onUnmounted, type Ref, ref } from 'vue'

export function useActivated(): {
    isActivated: Ref<boolean>
} {
    const isActivated = ref(true)

    onMounted(() => {
        isActivated.value = true
    })

    onUnmounted(() => {
        isActivated.value = false
    })

    return { isActivated }
}
